import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

import { UICarbonNumberField } from '@futrli/ui-components';

import styles from '../repeating-method.scss';

interface EndAfterRepeatCountProps {
  disabled?: boolean;
  onChange: (value: string) => void;
  value: string;
}

const MAX_REPEATS = 1000;

export const EndAfterRepeatCount = ({ disabled, onChange, value }: EndAfterRepeatCountProps) => (
  <div className={clsx(styles.occurrencesContainer, styles.spaceBottom, styles.spaceRight, styles.spaceTop)}>
    <UICarbonNumberField
      clampMax={MAX_REPEATS}
      clampMin={1}
      disabled={disabled}
      value={value}
      style={{ marginRight: 16, marginTop: 16 }}
      className={styles.periodInput}
      onChange={onChange}
      size="large"
    />
    <FormattedMessage id="predict.occurrences" defaultMessage="occurrences" />
  </div>
);
